export default {
    'diagram3-5d': {
      'exercise-title': `PCI ENERGY SERVICES GROUP – PROBLEM`,
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header-1': 'Westinghouse Fossil Fuels',
      'diagram-header-2': 'Siemens Power Corp.',
      'middle-left-box': 'PCI Energy',
      'middle-right-box': '7 Power Gen. Eqpt. Mfg. Sites',
      'bottom-box': 'Siemens Westinghouse Power Corp. Orlando, Florida',
      'bottom-box-list': `
        <ul>
            <li>NC-1</li>
            <li>NC-2</li>
            <li>AL</li>
        </ul>
        <ul>
            <li>WI</li>
            <li>IN</li>
            <li>PA</li>
            <li>Ont.</li>
        </ul>
      `,
      'disturbing-event': 'DISTURBING EVENT',
      'situation-desc': `
        <br/>
        W & S are merging Fossil Fuels Divisions, will integrate their manufacturing operations
        <br/>
        - Adding 3 W plants physically to the SWPC Network
        <br/>
        - Closing the other 4 W plants, transferring their business ops. and IS systems to other sites in the SWPC Network
        <ul>
            <li>Must align each IS to the IS of the receiving plant</li>
        </ul>
        <br/>
        <br/>
        PCI is defining the structure of the SWPC Network required to support the integrated mfg. operations
        <br/>
        - Will realign the mfg. capabilities at each production site
        <br/>
        - Will make certain that IS data conversion activities for the transferred plants are completed well in advance of the rollout of its business operations
        <ul>
            <li>Info Systems in Orlando must be up and running smoothly, without delay, before transfer the of the bus. operations of the 4 closing plants</li>
        </ul>
        `
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram3/i18n/en.js